// ── Lieferanten / Datenquellen API client ────────────────────────────────────
// Backed by /api/lieferanten (functions/intranet/src/functions/lieferanten.js,
// dim.Lieferanten table, migration 015_dim_lieferanten.sql).
//
// Auth is enforced server-side: writes require IT.Admin | CEO | Verwaltung.Leitung.
// Reads are open to any authenticated user.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../../../shared/api'
import type { Lieferant } from '../lib/types'

const QUERY_KEY = ['lieferanten'] as const

export function useLieferanten() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => api.get<Lieferant[]>('/api/lieferanten'),
    staleTime: 60_000,
  })
}

export function useUpsertLieferant() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (l: Lieferant) =>
      api.put<Lieferant>(`/api/lieferanten/${encodeURIComponent(l.id)}`, l),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}

export function useToggleLieferantActive() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, active }: { id: string; active: boolean }) =>
      api.patch<Lieferant>(
        `/api/lieferanten/${encodeURIComponent(id)}/active`,
        { active },
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}
